import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PayPalForm from "../components/PayPalForm";
import SuccessModal from "../components/SuccessModal";
import { AuthContext } from "../context/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import { Alert, Page, PageHeader, PageLoader, Panel } from "../components/ui";

const BuyCredits = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const myBooleanParam = queryParams.get("success") === "true";
  const [loading, setLoading] = useState(true);
  const [uploaderText, setUploaderText] = useState(null);

  useEffect(() => {
    if (myBooleanParam) {
      const timer = setTimeout(() => {
        navigate("/my-files");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [myBooleanParam, navigate]);

  useEffect(() => {
    const fetchUploaderText = async () => {
      try {
        const response = await axiosInstance.get("/application-configuration");
        const uploaderText = response.data.uploader_text;
        if (uploaderText !== null && uploaderText !== "") {
          setUploaderText(uploaderText);
        }
      } catch (error) {
        console.error("Failed to fetch banner text", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUploaderText();
  }, []);

  // A configured uploader notice replaces the purchase flow entirely — e.g.
  // while payments are handled another way.
  if (uploaderText) {
    return (
      <Page width="max-w-3xl">
        <PageHeader title="Buy Credits" onBack={() => window.history.back()} />
        <Alert tone="info">{uploaderText}</Alert>
      </Page>
    );
  }

  if (loading) {
    return (
      <Page width="max-w-3xl">
        <PageHeader title="Buy Credits" onBack={() => window.history.back()} />
        <PageLoader />
      </Page>
    );
  }

  return (
    <Page width="max-w-3xl">
      <PageHeader title="Buy Credits" subtitle="1 CRD = 1 EUR" onBack={() => window.history.back()} />

      <Alert tone="info">
        Thank you for trusting <strong>VDP Tuning!</strong> Your payment will be securely processed
        via PayPal, and credits will automatically be converted into CRS and added to your VDP
        Tuning account.
      </Alert>

      {myBooleanParam ? (
        <SuccessModal message={"You bought credits successfully"} />
      ) : (
        <Panel className="text-center">
          <p className="text-3xl font-extrabold">
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              1 CRD = 1 EUR
            </span>
          </p>
          <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">
            Credits land in your account as soon as PayPal confirms the payment.
          </p>
          <div className="mt-6 flex justify-center">
            <PayPalForm userId={user.id} />
          </div>
        </Panel>
      )}
    </Page>
  );
};

export default BuyCredits;
